import { render, staticRenderFns } from "./bbssend.vue?vue&type=template&id=47d8cad7&scoped=true"
import script from "./bbssend.vue?vue&type=script&lang=js"
export * from "./bbssend.vue?vue&type=script&lang=js"
import style0 from "./bbssend.vue?vue&type=style&index=0&id=47d8cad7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8cad7",
  null
  
)

export default component.exports